import React from "react";
import MobileMenuButton from "./sub/MobileMenuButton";
import SearchInput from "./sub/SearchInput";
import MessageButton from "./sub/MessageButton";
import NotificationButton from "./sub/NotificationButton";
import ProfileMenu from "./sub/UserProfileMenu"; // <-- nouveau
import { Leaf } from "lucide-react";

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  return (
    <div className="flex mx-auto w-full">
      <header className="sticky top-0 z-40 bg-gradient-to-r from-green-900 to-green-800 border-b border-accent/30 w-full shadow-lg backdrop-blur-sm">
        <div className="flex items-center justify-between px-4 py-3 lg:px-10 w-full">
          {/* Left */}
          <div className="flex items-center gap-3">
            <MobileMenuButton onClick={onMenuClick} />
            <div className="inline-flex items-center gap-2 bg-accent/10 backdrop-blur-sm rounded-full px-2 sm:px-4 py-1 border border-accent/30 shadow-glow">
              <Leaf className="w-4 h-4 text-accent animate-pulse" />
              <span className="text-accent font-semibold text-[10px] py-1 sm:text-sm tracking-wide">User Dashboard</span>
            </div>
          </div>

          {/* Search */}
          <div className="hidden md:flex flex-1 max-w-md mx-6">
            <SearchInput className="w-full" />
          </div>

          {/* Right */}
          <div className="flex items-center gap-3">
            <MessageButton />
            <NotificationButton />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;